import { Component, DestroyRef, OnInit, inject, input, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { AsyncPipe, NgStyle } from '@angular/common';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { ArticlesService } from '../../services/articles.service';
import { EditingService } from '../../services/editing.service';
import { ModalService } from '../../shared/modal/modal.service';
import { ConfirmComponent } from '../../shared/modal/confirm/confirm.component';
import { BlogpostComponent } from '../../shared/forms/blogpost/blogpost.component';

@Component({
  selector: 'app-blog-list-item',
  templateUrl: './blog-list-item.component.html',
  styleUrls: ['./blog-list-item.component.scss'],
  imports: [RouterLink, AsyncPipe, NgStyle]
})
export class BlogListItemComponent implements OnInit {
  private modal = inject(ModalService);
  private storage = inject(AngularFireStorage);
  private articleService = inject(ArticlesService);
  private editService = inject(EditingService);
  private destroyRef = inject(DestroyRef);

  readonly editMode = this.editService.editMode;
  readonly article = input.required<any>();
  readonly deleted = output<string>();

  image;

  ngOnInit() {
    this.getImage();
  }

  private getImage() {
    const attributes = this.article().attributes;
    if (attributes.image != null) {
      this.image = this.storage.ref(attributes.image).getDownloadURL();
    } else if (attributes.fileLink != null) {
      this.image = attributes.fileLink;
    }
  }

  editArticle() {
    this.modal.open(BlogpostComponent, {data: {type: this.article().type, title: 'Edit Post', content: this.article()}})
      .afterClosed.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(response => {
        this.articleService.saveArticles(response);
      });
  }

  deleteArticle() {
    this.modal.open(ConfirmComponent, {data: {message: 'Delete this post?'}})
      .afterClosed.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(confirmed => {
        if (!confirmed) {
          return;
        }
        this.articleService.deleteArticle({type: this.article().type, id: this.article().id})
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(() => this.deleted.emit(this.article().id));
      });
  }
}
